module.exports = __webpack_public_path__ + "static/media/Sara-Kalim.453a96f4.jpg";